import { render, staticRenderFns } from "./upImg.vue?vue&type=template&id=3fe69923&scoped=true"
import script from "./upImg.vue?vue&type=script&lang=js"
export * from "./upImg.vue?vue&type=script&lang=js"
import style0 from "./upImg.vue?vue&type=style&index=0&id=3fe69923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe69923",
  null
  
)

export default component.exports